import React from "react";
import EconomyWorkspace from "../../../components/dashboard/accounting/economy/EconomyWorkspace";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  ChartBarIcon,
  DocumentTextIcon,
  ArrowPathIcon,
} from "@heroicons/react/24/outline";
import { AccountingSummarySection } from "../../../components/dashboard/accounting/AccountingSummarySection";

export const AccountingOverview = () => {
  const { t } = useTranslation();

  const shortcuts = [
    {
      title: t("accounting.menu.supplier_invoices"),
      description: t("accounting.menu.supplier_invoices_hint"),
      to: "/dashboard/supplier-invoices",
      icon: DocumentTextIcon,
    },
    {
      title: t("accounting.menu.customer_invoices"),
      description: t("accounting.menu.customer_invoices_hint"),
      to: "/dashboard/customer-invoices",
      icon: DocumentTextIcon,
    },
    {
      title: t("accounting.menu.ledger"),
      description: t("accounting.menu.ledger_hint"),
      to: "/dashboard/accounting/ledger",
      icon: ChartBarIcon,
    },
    {
      title: t("accounting.menu.result_report"),
      description: t("accounting.menu.result_report_hint"),
      to: "/dashboard/accounting/result-report",
      icon: DocumentTextIcon,
    },
    {
      title: t("accounting.menu.project_summary"),
      description: t("accounting.menu.project_summary_hint"),
      to: "/dashboard/accounting/project-summary",
      icon: ChartBarIcon,
    },
    {
      title: t("accounting.menu.tripletex_import"),
      description: t("accounting.menu.tripletex_import_hint"),
      to: "/dashboard/accounting/tripletex-import",
      icon: ArrowPathIcon,
    },
  ];

  return (
    <EconomyWorkspace>
      <details className="eco-legacy">
        <summary>{t("accounting.menu.title")} · {t("accounting.menu.sections")}</summary>
        <div className="eco-stack">
          <div className="eco-accounting-summary text-slate-950"><AccountingSummarySection /></div>

          <section className="eco-card">
            <h3>
              {t("accounting.menu.sections")}
            </h3>
            <div className="eco-shortcuts">
              {shortcuts.map((item) => (
                <Link
                  key={item.to}
                  to={item.to}
                  className="eco-shortcut"
                >
                  <div className="flex items-center gap-3">
                    <div className="eco-shortcut-icon">
                      <item.icon className="h-5 w-5" />
                    </div>
                    <div>
                      <div className="font-medium">{item.title}</div>
                      <p className="eco-muted">{item.description}</p>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </section>
        </div>
      </details>
    </EconomyWorkspace>
  );
};

export const AccountingOverviewPage = AccountingOverview;
export default AccountingOverviewPage;
